/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DoubleMaterialityConsolidatedResultRowDto } from '../models';
// @ts-ignore
import type { DoubleMaterialityResultRowDto } from '../models';
/**
 * DoubleMaterialityResultsApi - axios parameter creator
 * @export
 */
export const DoubleMaterialityResultsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} year Year of the survey
         * @param {number} [impactThreshold] Threshold that determines whether an impact score is active in consolidated view
         * @param {number} [financialThreshold] Threshold that determines whether risk or opportunity scores are active in consolidated view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityResultsControllerGetConsolidatedResults: async (year: number, impactThreshold?: number, financialThreshold?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('doubleMaterialityResultsControllerGetConsolidatedResults', 'year', year)
            const localVarPath = `/api/dm/results/consolidated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (impactThreshold !== undefined) {
                localVarQueryParameter['impactThreshold'] = impactThreshold;
            }

            if (financialThreshold !== undefined) {
                localVarQueryParameter['financialThreshold'] = financialThreshold;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} year Year of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityResultsControllerGetResults: async (year: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'year' is not null or undefined
            assertParamExists('doubleMaterialityResultsControllerGetResults', 'year', year)
            const localVarPath = `/api/dm/results`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DoubleMaterialityResultsApi - functional programming interface
 * @export
 */
export const DoubleMaterialityResultsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DoubleMaterialityResultsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} year Year of the survey
         * @param {number} [impactThreshold] Threshold that determines whether an impact score is active in consolidated view
         * @param {number} [financialThreshold] Threshold that determines whether risk or opportunity scores are active in consolidated view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityResultsControllerGetConsolidatedResults(year: number, impactThreshold?: number, financialThreshold?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DoubleMaterialityConsolidatedResultRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityResultsControllerGetConsolidatedResults(year, impactThreshold, financialThreshold, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityResultsApi.doubleMaterialityResultsControllerGetConsolidatedResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} year Year of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async doubleMaterialityResultsControllerGetResults(year: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DoubleMaterialityResultRowDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.doubleMaterialityResultsControllerGetResults(year, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DoubleMaterialityResultsApi.doubleMaterialityResultsControllerGetResults']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DoubleMaterialityResultsApi - factory interface
 * @export
 */
export const DoubleMaterialityResultsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DoubleMaterialityResultsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} year Year of the survey
         * @param {number} [impactThreshold] Threshold that determines whether an impact score is active in consolidated view
         * @param {number} [financialThreshold] Threshold that determines whether risk or opportunity scores are active in consolidated view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityResultsControllerGetConsolidatedResults(year: number, impactThreshold?: number, financialThreshold?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DoubleMaterialityConsolidatedResultRowDto>> {
            return localVarFp.doubleMaterialityResultsControllerGetConsolidatedResults(year, impactThreshold, financialThreshold, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} year Year of the survey
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        doubleMaterialityResultsControllerGetResults(year: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<DoubleMaterialityResultRowDto>> {
            return localVarFp.doubleMaterialityResultsControllerGetResults(year, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DoubleMaterialityResultsApi - object-oriented interface
 * @export
 * @class DoubleMaterialityResultsApi
 * @extends {BaseAPI}
 */
export class DoubleMaterialityResultsApi extends BaseAPI {
    /**
     * 
     * @param {number} year Year of the survey
     * @param {number} [impactThreshold] Threshold that determines whether an impact score is active in consolidated view
     * @param {number} [financialThreshold] Threshold that determines whether risk or opportunity scores are active in consolidated view
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityResultsApi
     */
    public doubleMaterialityResultsControllerGetConsolidatedResults(year: number, impactThreshold?: number, financialThreshold?: number, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityResultsApiFp(this.configuration).doubleMaterialityResultsControllerGetConsolidatedResults(year, impactThreshold, financialThreshold, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} year Year of the survey
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DoubleMaterialityResultsApi
     */
    public doubleMaterialityResultsControllerGetResults(year: number, options?: RawAxiosRequestConfig) {
        return DoubleMaterialityResultsApiFp(this.configuration).doubleMaterialityResultsControllerGetResults(year, options).then((request) => request(this.axios, this.basePath));
    }
}

